import getMarkerName from './getMarkerName';
export default function isBeginningOfTime(marker) {
  const markerName = getMarkerName(marker);
  return marker === undefined || markerName === undefined;
}